import React, {useState, useEffect, useRef} from 'react';
import {withTranslation} from 'react-i18next';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import axios from "axios"; import Cookies from "js-cookie";
import {InputText} from "primereact/inputtext";
import moment from "moment";
import {addLocale, locale} from "primereact/api";

const MonologListComponent = (props) => {
  const {t} = props;
  const [monolog, setMonolog] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rows, setRows] = useState(10);
  const dt = useRef(null);
  const filterTextMatchModes = [
    {label: t('filter_like'), value: 'like'},
    {label: t('filter_equals'), value: '='},
    {label: t('filter_not_equals'), value: '!='},
  ]
  const filterNumberMatchModes = [
    {label: t('filter_between_number'), value: 'between'},
    {label: t('filter_equals'), value: '='},
    {label: t('filter_not_equals'), value: '!='},
    {label: t('filter_greather_than'), value: '>'},
    {label: t('filter_greather_than_or_equals'), value: '>='},
    {label: t('filter_less_than'), value: '<'},
    {label: t('filter_less_than_or_equals'), value: '<='},
  ]
  const filterDateMatchModes = [
    {label: t('filter_between_date'), value: 'between'},
    {label: t('filter_equals'), value: '='},
    {label: t('filter_not_equals'), value: '!='},
    {label: t('filter_greather_than'), value: '>'},
    {label: t('filter_greather_than_or_equals'), value: '>='},
    {label: t('filter_less_than'), value: '<'},
    {label: t('filter_less_than_or_equals'), value: '<='},
  ]
  const [lazyParams, setLazyParams] = useState({
    first: Number(localStorage.getItem('monolog_first')) || 0,
    rows: Number(localStorage.getItem('monolog_rows')) || rows,
    page: Number(localStorage.getItem('monolog_page')) || 0,
    sortField: localStorage.getItem('monolog_sortField') || 'id',
    sortOrder: Number(localStorage.getItem('monolog_sortOrder')) || -1,
    filters: JSON.parse(localStorage.getItem('monolog_filters')) || null,
  });
  let loadLazyTimeout = null;
  const loadLazyData = () => {
    setLoading(true);
    if (loadLazyTimeout) {
      clearTimeout(loadLazyTimeout);
    }
    loadLazyTimeout = setTimeout(() => {
      let query = window.App.transformQueryParams(lazyParams)
      axios({
        method: 'get',
        url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "system-admin/monolog-log" + query,
        params: {},
        headers: {
          'Authorization': 'Bearer ' + Cookies.get("userToken"),
          "Sys-name": Cookies.get("instanceId"),
          "Preferred-locale": Cookies.get("language")
        }
      })
        .then(response => {
          setTotalRecords(response.data.data.total_item_count);
          setMonolog(response.data.data.items);
          setLoading(false);
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
          setLoading(false);
        })
    }, Math.random() * 1000 + 250);
  }
  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onFilter = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParams(_lazyParams);
  }
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: 10, value: 10},
        {label: 20, value: 20},
        {label: 50, value: 50},
        {label: 200, value: 200}
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', monologSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                    />
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', monologSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button icon="pi pi-eye" className="p-button-sm  p-button-secondary"
                tooltip={t('show')}
                tooltipOptions={{ position: 'left' }}
                onClick={() => {
                  window.App.setState({
                    sidebarMonologShow: true,
                    propsMonolog: {id: rowData.id}
                  })
                }}/>
      </React.Fragment>
    );
  }

  addLocale('default', {
    clear: t('filter_clear'),
    apply: t('filter_apply'),
  });
  locale('default');

  useEffect(() => {
    if (lazyParams.filters) {
      document.getElementById('search').value = '';
      localStorage.setItem('monolog_filters', JSON.stringify(lazyParams.filters))
      if (lazyParams.sortField) {
        localStorage.setItem('monolog_sortField', lazyParams.sortField)
      }
      if (lazyParams.sortOrder) {
        localStorage.setItem('monolog_sortOrder', lazyParams.sortOrder)
      }
      if (lazyParams.first >= 0) {
        localStorage.setItem('monolog_first', lazyParams.first)
      }
      if (lazyParams.page >= 0) {
        localStorage.setItem('monolog_page', lazyParams.page)
      }
      if (lazyParams.rows) {
        localStorage.setItem('monolog_rows', lazyParams.rows)
        setRows(lazyParams.rows)
      }
    }
    loadLazyData();
  }, [lazyParams, window.App.state.rerenderMonologList])

  return (
    <>
      <div className={"p-grid"}>
        <div className={"p-col-12 p-lg-6 p-col-align-center"}>
          <h2 className={"p-m-0"}>{t('monolog_list')}</h2>
        </div>
        <div className={"p-col-12 p-lg-6 p-text-right p-col-align-center"}>
          {localStorage.getItem('monolog_filters') &&
            <a style={{color: "red"}} className={"p-button p-button-danger p-ml-2"}
               onClick={() => {
                 localStorage.removeItem('monolog_filters')
                 localStorage.removeItem('monolog_sortField')
                 localStorage.removeItem('monolog_sortOrder')
                 localStorage.removeItem('monolog_rows')
                 localStorage.removeItem('monolog_page')
                 localStorage.removeItem('monolog_first')
                 setLazyParams({
                   ...lazyParams,
                   filters: null
                 })
               }}
            >
              <i className={"pi pi-exclamation-triangle"}></i>&nbsp;{t('clear_filter')}
            </a>
          }
          <span className="p-input-icon-left p-ml-2">
              <i className="pi pi-search"/>
              <InputText id="search"
                         placeholder={t('search')}
                         onChange={(e) => {
                           clearTimeout(window.searchTimeout)
                           window.searchTimeout = setTimeout(function () {
                             localStorage.removeItem('monolog_filters')
                             localStorage.removeItem('monolog_sortField')
                             localStorage.removeItem('monolog_sortOrder')
                             localStorage.removeItem('monolog_rows')
                             localStorage.removeItem('monolog_page')
                             localStorage.removeItem('monolog_first')
                             setLazyParams({
                               ...lazyParams,
                               genericSearch: e.target.value,
                               filters: null
                             })
                           }, 1000)
                         }}
                         className={""}
              />
            </span>
        </div>
      </div>
      <DataTable
        ref={dt}
        size={"small"}
        emptyMessage={t('empty_message')}
        value={monolog} paginator first={lazyParams.first} totalRecords={totalRecords} onPage={onPage}
        onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
        onFilter={onFilter} filters={lazyParams.filters} loading={loading} lazy
        paginatorTemplate={pager} rows={rows} emptyMessage={t('empty_message')}
        autoLayout={true}
        filterDisplay="menu"
        responsiveLayout={window.App.state.responsiveLayout}
        breakpoint="1365px"
        stripedRows
        dataKey="id"
        selectionMode={"single"}
        onRowDoubleClick={(rowData) => {
          if(!rowData.data.deleted_at_snapshot) {
            window.App.setState({
              sidebarMonologShow: true,
              propsMonolog: {id: rowData.data.id}
            })
          }
        }}
      >
        
        <Column field="message" sortable header={t('message')}
                filter
                filterMatchMode="like"
                filterMatchModeOptions={filterTextMatchModes}></Column>
        <Column field="level_name" sortable header={t('level')}
                filter
                filterMatchMode="like"
                filterMatchModeOptions={filterTextMatchModes}
                body={(rowData) => {
                  if(rowData.level_name) {
                    return(
                      <>
                        {t(rowData.level_name.toLowerCase())}
                      </>
                    )
                  }
                }}></Column>
        <Column field="used_system" sortable header={t('used_system')}
                filter
                filterMatchMode="like"
                filterMatchModeOptions={filterTextMatchModes}></Column>
        <Column field="channel" sortable header={t('channel')}
                filter
                filterMatchMode="like"
                filterMatchModeOptions={filterTextMatchModes}></Column>
        <Column field="at" sortable header={t('created_at')}
                filter
                filterMatchMode="between"
                filterMatchModeOptions={filterDateMatchModes}
                body={(rowData) => {
          if (rowData.at !== null) {
            return (
              <span>{moment.utc(rowData.at).local().format(t('YYYY-MM-DD HH:mm:ss'))}</span>
            )
          }
        }}></Column>
        <Column field="at" sortable header={t('updated_at')}
                filter
                filterMatchMode="between"
                filterMatchModeOptions={filterDateMatchModes}
                body={(rowData) => {
          if (rowData.at !== null) {
            return (
              <span>{moment.utc(rowData.at).local().format(t('YYYY-MM-DD HH:mm:ss'))}</span>
            )
          }
        }}></Column>
        <Column body={actionBodyTemplate} className={"p-py-0 p-text-nowrap p-text-right"}></Column>
      </DataTable>
    </>
  )
}
export default withTranslation('common')(MonologListComponent);
